import Staff from '@/service/staff'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getstaffs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Staff.getstaffs(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getstaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Staff.getstaff(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addstaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Staff.addstaff(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatestaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Staff.updatestaff(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateme(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Staff.updateme(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletestaff(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Staff.deletestaff(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getorgportalmenutree(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Staff.getorgportalmenutree(payload), {
        type: 'list',
        success,
        fail
      })
    }
  }
}
